// Tiny path-based router. The viewer is a single route — anything under
// `/preview/:code` resolves to a share code; everything else is a 404 page.

export interface RouteMatch {
  code: string;
  /** True if `?fixture=1` is present — boots a hardcoded payload, no API call. */
  fixture: boolean;
}

const PREVIEW_PREFIX = "/preview/";

/**
 * Parses the current location into a `RouteMatch`, or returns null if the
 * path is not a preview URL. We accept either `/preview/abc123` or
 * `/preview/abc123/` (trailing slash tolerated) but reject empty codes and
 * codes containing slashes (no nested routes today).
 */
export function parseRoute(
  pathname: string = location.pathname,
  search: string = location.search,
): RouteMatch | null {
  if (!pathname.startsWith(PREVIEW_PREFIX)) return null;
  const remainder = pathname.slice(PREVIEW_PREFIX.length).replace(/\/$/, "");
  if (!remainder || remainder.includes("/")) return null;
  const params = new URLSearchParams(search);
  return {
    code: remainder,
    fixture: params.get("fixture") === "1",
  };
}
